// extracted by mini-css-extract-plugin
export var oService = "service-module--o-service--2Q9dV";
export var oService__slider = "service-module--o-service__slider--3Fkwx";
export var oService__slider__slide = "service-module--o-service__slider__slide--FZrTC";
export var oService__slider__slide__decoration = "service-module--o-service__slider__slide__decoration--2Hwsy";
export var oService__sliderMain = "service-module--o-service__slider--main--HkeqH";
export var oService__swiper = "service-module--o-service__swiper--2a3Md";
export var oService__controller = "service-module--o-service__controller--1NigL";
export var active = "service-module--active--2yT6X";
export var oService__attention = "service-module--o-service__attention--1Zgiq";
export var oService__charactor = "service-module--o-service__charactor--1z_87";
export var visible1 = "service-module--visible-1--35sbp";
export var visible2 = "service-module--visible-2--VajQQ";
export var visible3 = "service-module--visible-3--1h2Ai";
export var visible4 = "service-module--visible-4--1AkXV";
export var visible = "service-module--visible--3XWyo";
export var subcopyBefore = "service-module--subcopy-before--1W5py";
export var subcopyAfter = "service-module--subcopy-after--3GXSG";
export var service__slider = "service-module--service__slider--2eaHy";
export var standby = "service-module--standby--3EnLu";
export var lContent__inner = "service-module--l-content__inner--2OIAl";